import { render, staticRenderFns } from "./WhyServicesPage.vue?vue&type=template&id=f2848886&scoped=true"
import script from "./WhyServicesPage.vue?vue&type=script&lang=js"
export * from "./WhyServicesPage.vue?vue&type=script&lang=js"
import style0 from "./WhyServicesPage.vue?vue&type=style&index=0&id=f2848886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2848886",
  null
  
)

export default component.exports